// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__Pit26","header":"MessagesList_header__1ylkk","chat":"MessagesList_chat__8aHPk"};